// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"ee3647d2","43":"58b64a3c","117":"dd1589a2","149":"a7b1a163","337":"be13d712","486":"7c36539e","575":"95015b24","636":"2a146521","765":"ef62be28","817":"e1dac311","932":"b40a6a0b","944":"91aad5a8"}[chunkId] + ".chunk.js";
};